// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#409EFF","subMenuActiveText":"#f4f4f5","menuBg":"#304156","menuHover":"#263445","menuLightBg":"#fff","menuLightHover":"#f0f1f5","subMenuBg":"#1f2d3d","subMenuHover":"#001528","sideBarWidth":"200px","sidebarTitle":"#fff","sidebarLightTitle":"#001529"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/index.scss
// module id = N9P1
// module chunks = 2